import { useCurrentUser } from 'lib/CurrentUserProvider'
import { getRemoteId } from 'lib/DataModel'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { UNSAFE_DataRouterContext as DataRouterContext } from 'react-router'
import { DataRouterContextObject } from 'react-router/dist/lib/context'
import { hasExactRouteMatch } from './routing-helpers'

export default function NavigateToDefault() {
  const { router: { routes } } = useContext(DataRouterContext) as DataRouterContextObject
  const { accessibleClients, accessibleVendorContracts } = useCurrentUser()
  const defaultPath = defaultDashboard({ routes, accessibleClients, accessibleVendorContracts })

  return <Navigate to={defaultPath}/>
}

function defaultDashboard({ routes, accessibleClients, accessibleVendorContracts }) {
  if (hasExactRouteMatch(routes, "/dashboard")) {
    return "/dashboard"
  }
  else if(hasExactRouteMatch(routes, "/clients/:clientId/dashboard")) {
    return `/clients/${getRemoteId(accessibleClients[0])}/dashboard`
  }
  else if(hasExactRouteMatch(routes, "/contracts/:contractId/dashboard")) {
    return `/contracts/${getRemoteId(accessibleVendorContracts[0])}/dashboard`
  }
  else {
    throw new Error("No default dashboard path found")
  }
}
